import {
  PlannedQtyDeviationCreateRequest,
  PlannedQtyDeviationInputs,
  PlannedQtyDeviationUpdateInputs,
  PlannedQtyDeviationUpdateRequest,
} from '../../../types/app/plannedQtyDeviation.types';

export const convertDataFromInputToCreateRequest = (
  data: PlannedQtyDeviationInputs,
): PlannedQtyDeviationCreateRequest => ({
  assetId: data.assetId,
  qty: data.qty,
  time: data.time,
  date: data.date,
  comment: data.comment,
});

export const convertDataFromInputToUpdateRequest = (
  data: PlannedQtyDeviationUpdateInputs,
): PlannedQtyDeviationUpdateRequest => ({
  id: data.id,
  assetId: data.assetId,
  qty: data.qty,
  time: data.time,
  comment: data.comment,
});
